import { render, staticRenderFns } from "./textarea-quarternary.vue?vue&type=template&id=58be4473&scoped=true&"
import script from "./textarea-quarternary.vue?vue&type=script&lang=js&"
export * from "./textarea-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58be4473",
  null
  
)

export default component.exports